import CreateEditService from "@/app/shared/settings/services/create-edit";
import routes from "@/routers/routes";
import { Service } from "@/types";
import { useState, useEffect } from "react";
import PageHeader from "../page-header";
import { useParams } from "react-router-dom";
import { fetchServiceById } from "@/server/api-services";

export default function EditServicePage() {
    const { Id } = useParams();

    const [service, setService] = useState({} as Service);

    const pageHeader = {
        title: "Create System Service",
        breadcrumb: [
            {
                href: routes.eCommerce.dashboard,
                name: "home",
            },
            {
                name: "Add New Service",
            },
        ],
    };

    useEffect(() => {
        getService();
    }, []);

    const getService = async () => {
        const response = await fetchServiceById(Id as string);

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Service;

        setService(data);
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                hideButton={true}
            ></PageHeader>

            <CreateEditService id="" isEdit={true} setting={service} />
        </>
    );
}
